var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 1050.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.867,113.55c60.126,0,108.867-10.959,108.867-24.477S168.993,64.6,108.867,64.6,0,75.554,0,89.073,48.742,113.55,108.867,113.55Z",
    transform: "translate(0 27.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.267,62.474H26.591a1.921,1.921,0,0,0-1.935,1.906V69.41a1.921,1.921,0,0,0,1.935,1.906H45.267A1.921,1.921,0,0,0,47.2,69.41V64.381A1.921,1.921,0,0,0,45.267,62.474Z",
    transform: "translate(10.312 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,62.474H42.435A1.921,1.921,0,0,0,40.5,64.381V69.41a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V64.381A1.921,1.921,0,0,0,61.111,62.474Z",
    transform: "translate(16.939 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,62.474H42.435A1.921,1.921,0,0,0,40.5,64.381V69.41a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V64.381A1.921,1.921,0,0,0,61.111,62.474Z",
    transform: "translate(16.939 26.178)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.951,62.474H58.275a1.921,1.921,0,0,0-1.935,1.906V69.41a1.921,1.921,0,0,0,1.935,1.906H76.951a1.921,1.921,0,0,0,1.935-1.906V64.381A1.921,1.921,0,0,0,76.951,62.474Z",
    transform: "translate(23.564 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,62.474H74.115a1.921,1.921,0,0,0-1.935,1.906V69.41a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V64.381A1.921,1.921,0,0,0,92.791,62.474Z",
    transform: "translate(30.189 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,62.474H74.115a1.921,1.921,0,0,0-1.935,1.906V69.41a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V64.381A1.921,1.921,0,0,0,92.791,62.474Z",
    transform: "translate(30.189 26.178)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.634,62.474H89.958a1.921,1.921,0,0,0-1.935,1.906V69.41a1.921,1.921,0,0,0,1.935,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V64.381A1.921,1.921,0,0,0,108.634,62.474Z",
    transform: "translate(36.815 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,62.474H105.8a1.921,1.921,0,0,0-1.936,1.906V69.41a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V64.381A1.921,1.921,0,0,0,124.475,62.474Z",
    transform: "translate(43.44 26.178)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,62.474H105.8a1.921,1.921,0,0,0-1.936,1.906V69.41a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V64.381A1.921,1.921,0,0,0,124.475,62.474Z",
    transform: "translate(43.44 26.178)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,65.1h18.677a1.921,1.921,0,0,0,1.934-1.906V58.168a1.921,1.921,0,0,0-1.934-1.906H105.8a1.921,1.921,0,0,0-1.934,1.906V63.2A1.921,1.921,0,0,0,105.8,65.1Z",
    transform: "translate(43.44 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,65.1h18.676a1.92,1.92,0,0,0,1.934-1.906V58.168a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,89.957,65.1Z",
    transform: "translate(36.815 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,65.1h18.676a1.92,1.92,0,0,0,1.934-1.906V58.168a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,89.957,65.1Z",
    transform: "translate(36.815 23.548)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.117,65.1H92.793A1.921,1.921,0,0,0,94.728,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H74.117a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,74.117,65.1Z",
    transform: "translate(30.19 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,65.1H76.95A1.921,1.921,0,0,0,78.885,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,58.273,65.1Z",
    transform: "translate(23.563 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,65.1H76.95A1.921,1.921,0,0,0,78.885,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,58.273,65.1Z",
    transform: "translate(23.563 23.548)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.434,65.1H61.11A1.921,1.921,0,0,0,63.045,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H42.434A1.921,1.921,0,0,0,40.5,58.168V63.2A1.921,1.921,0,0,0,42.434,65.1Z",
    transform: "translate(16.938 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,65.1H45.27A1.921,1.921,0,0,0,47.2,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,26.594,65.1Z",
    transform: "translate(10.313 23.548)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,65.1H45.27A1.921,1.921,0,0,0,47.2,63.2V58.168a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906V63.2A1.921,1.921,0,0,0,26.594,65.1Z",
    transform: "translate(10.313 23.548)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.267,50.049H26.591a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H45.267A1.921,1.921,0,0,0,47.2,56.985V51.956A1.921,1.921,0,0,0,45.267,50.049Z",
    transform: "translate(10.312 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,50.049H42.435A1.921,1.921,0,0,0,40.5,51.956v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V51.956A1.921,1.921,0,0,0,61.111,50.049Z",
    transform: "translate(16.939 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,50.049H42.435A1.921,1.921,0,0,0,40.5,51.956v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V51.956A1.921,1.921,0,0,0,61.111,50.049Z",
    transform: "translate(16.939 20.919)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.951,50.049H58.275a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H76.951a1.921,1.921,0,0,0,1.935-1.906V51.956A1.921,1.921,0,0,0,76.951,50.049Z",
    transform: "translate(23.564 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,50.049H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V51.956A1.921,1.921,0,0,0,92.791,50.049Z",
    transform: "translate(30.189 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,50.049H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V51.956A1.921,1.921,0,0,0,92.791,50.049Z",
    transform: "translate(30.189 20.919)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.634,50.049H89.958a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V51.956A1.921,1.921,0,0,0,108.634,50.049Z",
    transform: "translate(36.815 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,50.049H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V51.956A1.921,1.921,0,0,0,124.475,50.049Z",
    transform: "translate(43.44 20.919)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,50.049H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V51.956A1.921,1.921,0,0,0,124.475,50.049Z",
    transform: "translate(43.44 20.919)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,52.679h18.677a1.921,1.921,0,0,0,1.934-1.906V45.743a1.921,1.921,0,0,0-1.934-1.906H105.8a1.921,1.921,0,0,0-1.934,1.906v5.029A1.921,1.921,0,0,0,105.8,52.679Z",
    transform: "translate(43.44 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,52.679h18.676a1.92,1.92,0,0,0,1.934-1.906V45.743a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,89.957,52.679Z",
    transform: "translate(36.815 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,52.679h18.676a1.92,1.92,0,0,0,1.934-1.906V45.743a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,89.957,52.679Z",
    transform: "translate(36.815 18.289)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.117,52.679H92.793a1.921,1.921,0,0,0,1.935-1.906V45.743a1.921,1.921,0,0,0-1.935-1.906H74.117a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,74.117,52.679Z",
    transform: "translate(30.19 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,52.679H76.95a1.921,1.921,0,0,0,1.935-1.906V45.743a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,58.273,52.679Z",
    transform: "translate(23.563 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,52.679H76.95a1.921,1.921,0,0,0,1.935-1.906V45.743a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,58.273,52.679Z",
    transform: "translate(23.563 18.289)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.434,52.679H61.11a1.921,1.921,0,0,0,1.935-1.906V45.743a1.921,1.921,0,0,0-1.935-1.906H42.434A1.921,1.921,0,0,0,40.5,45.743v5.029A1.921,1.921,0,0,0,42.434,52.679Z",
    transform: "translate(16.938 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,52.679H45.27A1.921,1.921,0,0,0,47.2,50.772V45.743a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,26.594,52.679Z",
    transform: "translate(10.313 18.289)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,52.679H45.27A1.921,1.921,0,0,0,47.2,50.772V45.743a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906v5.029A1.921,1.921,0,0,0,26.594,52.679Z",
    transform: "translate(10.313 18.289)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.267,37.927H26.591a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H45.267A1.921,1.921,0,0,0,47.2,44.863V39.834A1.921,1.921,0,0,0,45.267,37.927Z",
    transform: "translate(10.312 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,37.927H42.435A1.921,1.921,0,0,0,40.5,39.834v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V39.834A1.921,1.921,0,0,0,61.111,37.927Z",
    transform: "translate(16.939 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,37.927H42.435A1.921,1.921,0,0,0,40.5,39.834v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V39.834A1.921,1.921,0,0,0,61.111,37.927Z",
    transform: "translate(16.939 15.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.951,37.927H58.275a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H76.951a1.921,1.921,0,0,0,1.935-1.906V39.834A1.921,1.921,0,0,0,76.951,37.927Z",
    transform: "translate(23.564 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,37.927H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V39.834A1.921,1.921,0,0,0,92.791,37.927Z",
    transform: "translate(30.189 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,37.927H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V39.834A1.921,1.921,0,0,0,92.791,37.927Z",
    transform: "translate(30.189 15.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.634,37.927H89.958a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V39.834A1.921,1.921,0,0,0,108.634,37.927Z",
    transform: "translate(36.815 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,37.927H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V39.834A1.921,1.921,0,0,0,124.475,37.927Z",
    transform: "translate(43.44 15.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,37.927H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V39.834A1.921,1.921,0,0,0,124.475,37.927Z",
    transform: "translate(43.44 15.788)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,40.557h18.677a1.921,1.921,0,0,0,1.934-1.906V33.621a1.921,1.921,0,0,0-1.934-1.906H105.8a1.921,1.921,0,0,0-1.934,1.906V38.65A1.921,1.921,0,0,0,105.8,40.557Z",
    transform: "translate(43.44 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,40.557h18.676a1.92,1.92,0,0,0,1.934-1.906V33.621a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,89.957,40.557Z",
    transform: "translate(36.815 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,40.557h18.676a1.92,1.92,0,0,0,1.934-1.906V33.621a1.92,1.92,0,0,0-1.934-1.906H89.957a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,89.957,40.557Z",
    transform: "translate(36.815 13.158)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.117,40.557H92.793a1.921,1.921,0,0,0,1.935-1.906V33.621a1.921,1.921,0,0,0-1.935-1.906H74.117a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,74.117,40.557Z",
    transform: "translate(30.19 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,40.557H76.95a1.921,1.921,0,0,0,1.935-1.906V33.621a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,58.273,40.557Z",
    transform: "translate(23.563 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,40.557H76.95a1.921,1.921,0,0,0,1.935-1.906V33.621a1.921,1.921,0,0,0-1.935-1.906H58.273a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,58.273,40.557Z",
    transform: "translate(23.563 13.158)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.434,40.557H61.11a1.921,1.921,0,0,0,1.935-1.906V33.621a1.921,1.921,0,0,0-1.935-1.906H42.434A1.921,1.921,0,0,0,40.5,33.621V38.65A1.921,1.921,0,0,0,42.434,40.557Z",
    transform: "translate(16.938 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,40.557H45.27A1.921,1.921,0,0,0,47.2,38.65V33.621a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,26.594,40.557Z",
    transform: "translate(10.313 13.158)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,40.557H45.27A1.921,1.921,0,0,0,47.2,38.65V33.621a1.921,1.921,0,0,0-1.935-1.906H26.594a1.921,1.921,0,0,0-1.935,1.906V38.65A1.921,1.921,0,0,0,26.594,40.557Z",
    transform: "translate(10.313 13.158)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.267,25.5H26.591a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H45.267A1.921,1.921,0,0,0,47.2,32.438V27.409A1.921,1.921,0,0,0,45.267,25.5Z",
    transform: "translate(10.312 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,25.5H42.435A1.921,1.921,0,0,0,40.5,27.409v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V27.409A1.921,1.921,0,0,0,61.111,25.5Z",
    transform: "translate(16.939 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.111,25.5H42.435A1.921,1.921,0,0,0,40.5,27.409v5.029a1.921,1.921,0,0,0,1.935,1.906H61.111a1.921,1.921,0,0,0,1.935-1.906V27.409A1.921,1.921,0,0,0,61.111,25.5Z",
    transform: "translate(16.939 10.529)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.951,25.5H58.275a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H76.951a1.921,1.921,0,0,0,1.935-1.906V27.409A1.921,1.921,0,0,0,76.951,25.5Z",
    transform: "translate(23.564 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,25.5H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V27.409A1.921,1.921,0,0,0,92.791,25.5Z",
    transform: "translate(30.189 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.791,25.5H74.115a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906H92.791a1.921,1.921,0,0,0,1.935-1.906V27.409A1.921,1.921,0,0,0,92.791,25.5Z",
    transform: "translate(30.189 10.529)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.634,25.5H89.958a1.921,1.921,0,0,0-1.935,1.906v5.029a1.921,1.921,0,0,0,1.935,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V27.409A1.921,1.921,0,0,0,108.634,25.5Z",
    transform: "translate(36.815 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,25.5H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V27.409A1.921,1.921,0,0,0,124.475,25.5Z",
    transform: "translate(43.44 10.529)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.475,25.5H105.8a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.921,1.921,0,0,0,1.936-1.906V27.409A1.921,1.921,0,0,0,124.475,25.5Z",
    transform: "translate(43.44 10.529)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,4.805H104.567a1.921,1.921,0,0,0-1.934,1.906v5.715a1.921,1.921,0,0,0,1.934,1.906H125a1.92,1.92,0,0,0,1.934-1.906V6.712A1.92,1.92,0,0,0,125,4.805Z",
    transform: "translate(42.921 1.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.183,13.888h18.676a1.921,1.921,0,0,0,1.936-1.906V6.953a1.921,1.921,0,0,0-1.936-1.906H105.183a1.92,1.92,0,0,0-1.934,1.906v5.029A1.92,1.92,0,0,0,105.183,13.888Z",
    transform: "translate(43.183 1.871)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,28.132h18.676a1.92,1.92,0,0,0,1.934-1.906V21.2a1.92,1.92,0,0,0-1.934-1.906H89.957A1.921,1.921,0,0,0,88.022,21.2v5.029A1.921,1.921,0,0,0,89.957,28.132Z",
    transform: "translate(36.815 7.899)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.957,28.132h18.676a1.92,1.92,0,0,0,1.934-1.906V21.2a1.92,1.92,0,0,0-1.934-1.906H89.957A1.921,1.921,0,0,0,88.022,21.2v5.029A1.921,1.921,0,0,0,89.957,28.132Z",
    transform: "translate(36.815 7.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.117,28.132H92.793a1.921,1.921,0,0,0,1.935-1.906V21.2a1.921,1.921,0,0,0-1.935-1.906H74.117A1.921,1.921,0,0,0,72.182,21.2v5.029A1.921,1.921,0,0,0,74.117,28.132Z",
    transform: "translate(30.19 7.899)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,28.132H76.95a1.921,1.921,0,0,0,1.935-1.906V21.2a1.921,1.921,0,0,0-1.935-1.906H58.273A1.921,1.921,0,0,0,56.338,21.2v5.029A1.921,1.921,0,0,0,58.273,28.132Z",
    transform: "translate(23.563 7.899)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.273,28.132H76.95a1.921,1.921,0,0,0,1.935-1.906V21.2a1.921,1.921,0,0,0-1.935-1.906H58.273A1.921,1.921,0,0,0,56.338,21.2v5.029A1.921,1.921,0,0,0,58.273,28.132Z",
    transform: "translate(23.563 7.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.434,28.132H61.11a1.921,1.921,0,0,0,1.935-1.906V21.2a1.921,1.921,0,0,0-1.935-1.906H42.434A1.921,1.921,0,0,0,40.5,21.2v5.029A1.921,1.921,0,0,0,42.434,28.132Z",
    transform: "translate(16.938 7.899)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,28.132H45.27A1.921,1.921,0,0,0,47.2,26.225V21.2a1.921,1.921,0,0,0-1.935-1.906H26.594A1.921,1.921,0,0,0,24.659,21.2v5.029A1.921,1.921,0,0,0,26.594,28.132Z",
    transform: "translate(10.313 7.899)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594,28.132H45.27A1.921,1.921,0,0,0,47.2,26.225V21.2a1.921,1.921,0,0,0-1.935-1.906H26.594A1.921,1.921,0,0,0,24.659,21.2v5.029A1.921,1.921,0,0,0,26.594,28.132Z",
    transform: "translate(10.313 7.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.947,80.3s1.97-6.558-.368-11.387a10.213,10.213,0,0,1-.852-6.5,17.229,17.229,0,0,1,.935-3.052",
    transform: "translate(6.997 24.861)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,57.654c0,.8,1.477,3.136,1.477,3.136s1.478-2.331,1.478-3.136a1.445,1.445,0,0,0-.433-1.029,1.493,1.493,0,0,0-2.089,0A1.445,1.445,0,0,0,16.3,57.654Z",
    transform: "translate(6.901 23.521)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.659,61.019c.438.676,2.97,1.842,2.97,1.842s-.046-2.75-.49-3.426a1.479,1.479,0,0,0-.931-.627,1.5,1.5,0,0,0-1.108.2,1.457,1.457,0,0,0-.641.915A1.44,1.44,0,0,0,14.659,61.019Z",
    transform: "translate(6.106 24.612)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,66.515c.729.363,3.5.112,3.5.112s-1.447-2.352-2.176-2.715a1.5,1.5,0,0,0-1.115-.065,1.471,1.471,0,0,0-.842.723,1.44,1.44,0,0,0-.089,1.1,1.463,1.463,0,0,0,.715.846Z",
    transform: "translate(5.973 26.726)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,70.5c.657.479,3.437.7,3.437.7s-1.024-2.559-1.679-3.038a1.491,1.491,0,0,0-2,.353,1.444,1.444,0,0,0,.25,1.99Z",
    transform: "translate(6.465 28.481)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.843,62.5c-.584.561-3.312,1.142-3.312,1.142s.668-2.671,1.252-3.239a1.479,1.479,0,0,1,.484-.309,1.5,1.5,0,0,1,1.131.016,1.476,1.476,0,0,1,.475.323,1.445,1.445,0,0,1-.03,2.061Z",
    transform: "translate(6.997 25.126)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.987,67.293c-.729.363-3.5.112-3.5.112s1.447-2.352,2.176-2.715a1.5,1.5,0,0,1,1.1-.045,1.471,1.471,0,0,1,.827.719,1.44,1.44,0,0,1,.092,1.083A1.462,1.462,0,0,1,20.987,67.293Z",
    transform: "translate(7.4 27.061)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.382,71.994c-.657.479-3.437.7-3.437.7s1.024-2.559,1.679-3.039a1.491,1.491,0,0,1,2,.353,1.444,1.444,0,0,1-.25,1.99Z",
    transform: "translate(7.595 29.114)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.066,47.961A16.763,16.763,0,0,1,97.2,65.578c-4.065,10.524,6.967,28.036,6.967,28.036s-.118-.017-.337-.056C89.045,90.976,81.7,74.315,89.92,61.94,92.976,57.338,95.487,51.942,94.066,47.961Z",
    transform: "translate(36.187 20.035)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.066,47.961A16.763,16.763,0,0,1,97.2,65.578c-4.065,10.524,6.967,28.036,6.967,28.036s-.118-.017-.337-.056C89.045,90.976,81.7,74.315,89.92,61.94,92.976,57.338,95.487,51.942,94.066,47.961Z",
    transform: "translate(36.187 20.035)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.312,47.961s4.065,8.693,0,15.786-.7,27,10.108,29.856",
    transform: "translate(37.934 20.035)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.809,68.142s8.215-1.294,8.964,5.965,15.8,8.258,15.8,8.258l-.283.185C94.861,90.586,82.988,87.668,84.774,77,85.44,73.033,85.381,69.046,82.809,68.142Z",
    transform: "translate(34.63 28.539)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.809,68.142s8.215-1.294,8.964,5.965,15.8,8.258,15.8,8.258l-.283.185C94.861,90.586,82.988,87.668,84.774,77,85.44,73.033,85.381,69.046,82.809,68.142Z",
    transform: "translate(34.63 28.539)",
    fill: "#f5f5f5",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.809,68.116s6.376,1.378,5.853,7.091,9.469,12.56,18.906,7.132",
    transform: "translate(34.63 28.565)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.953,83.356s-12.193-2.4-15.445-5.607-17.883-8.81-19.51-4.8S84.051,90.566,97.881,92.968s32.514,3.2,36.579,1.6S140.953,83.356,140.953,83.356Z",
    transform: "translate(38.867 30.021)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.878,88c13.819,2.4,32.515,3.2,36.58,1.6,3.1-1.221,5.253-7.08,6.1-9.808l.407.084s-2.438,9.61-6.5,11.214-22.765.8-36.58-1.6c-3.988-.694-5.129-2.323-4.7-4.384C93.5,86.444,94.9,87.477,97.878,88Z",
    transform: "translate(38.87 33.506)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.137,6.7a3.533,3.533,0,0,0-1.009-1.378c-3.273-2.937-8.564-2.047-12.626-3.843a5.457,5.457,0,0,0-2.912-.83c-1.419.216-2.738,1.812-3.975,1.1l.088.265-.088-.045.911,2.73a9.886,9.886,0,0,0,1.4,3,7.847,7.847,0,0,0-2.236,3.192,7.754,7.754,0,0,0,1.1,7.44,7.953,7.953,0,0,0,3.067,2.432c.044.091.085.183.127.276l.117.047a9.111,9.111,0,0,1,.6,1.9c-1.053.144-2.889,1.294-4.692,2.985l-3.608-.119a11.919,11.919,0,0,1-6.487-2.174L120.1,16.044a3.637,3.637,0,0,0-2.068.9c-1.341-1.376-2.478-2.8-2.383-3.666,0,0-5.021-9.258-6.847-4.63s3.424,9.489,3.424,9.489l3.329,4.251a17.624,17.624,0,0,0-.249,2.254c4.109,4.63,18.485,8.818,18.485,8.818l2.242.108.013.108a7.4,7.4,0,0,0-.2,1.768v.442c.114,7.384,1.14,29.977,1.14,29.977.2-.088.407-.168.618-.244l-.161,2.008A93.526,93.526,0,0,0,120.783,71.6c-7.075,2.646-7.3,5.732-7.3,5.732v27.229c-2.02,1.022-5.209,2.372-6.847,1.646-1.778-.781-2.751-.125-2.929.558a.876.876,0,0,0,0,.412.768.768,0,0,0,.068.175v.013a.718.718,0,0,0,.121.155c.685.662,15.519,6.392,18.942,5.51a2.355,2.355,0,0,0,.312-.1c.033-.013.061-.03.094-.045s.127-.058.186-.093.067-.045.1-.067.1-.067.152-.1.063-.056.094-.084.09-.075.128-.119.057-.065.085-.1.08-.086.114-.134.048-.071.075-.106.07-.1.1-.151.043-.073.063-.112.061-.11.09-.168.034-.075.05-.114.054-.123.078-.185.027-.075.043-.114.047-.136.067-.216a.4.4,0,0,1,.031-.11c.02-.075.041-.149.058-.216a.539.539,0,0,1,.023-.1c.017-.082.034-.164.048-.246a.211.211,0,0,1,.014-.093c.016-.089.028-.179.04-.267V109.9c.011-.1.021-.194.031-.291v-.06c.009-.1.014-.21.018-.315v-.4a18.253,18.253,0,0,0-.437-3.91l.86-23.19a130.314,130.314,0,0,0,13.431-.487l.491,11.068s0,7.274,2.511,10.58c2.149,2.829,4.631,15.344,5.3,18.9-.922,1.725-2.686,3.882-5.76,3.809,0,0-5.78-.492-5.454,1.078a.726.726,0,0,0,.037.121,1.411,1.411,0,0,0,.063.132c.024.041.051.082.081.125l.019.026q.049.068.111.142v.011c.04.045.081.091.127.136l.04.039c.053.052.105.1.167.157,2.966,2.646,20.311,3.086,20.311,3.086v-.123a28.384,28.384,0,0,0-1.151-7.8h.241s-2.511-22.265-4.564-24.909c0,0-.545-11.74.686-19.1l.219-.082c5.751-2.118,6.161-7.332,5.568-11.163,1.094.345,1.734.58,1.734.58s-.02-.166-.057-.462l.057.022s-.11-.7-.29-1.792a75.178,75.178,0,0,0-2.058-10.731c-.138-.546-.269-1.012-.39-1.363a23.04,23.04,0,0,1-1-4.578,53.459,53.459,0,0,1-.352-6.073,57.387,57.387,0,0,1,.63-8.1,49.043,49.043,0,0,0,.635-6.869,9.052,9.052,0,0,0-.138-1.941c-.3-1.374-1.651-2.267-3.05-2.836-.09-.037-.181-.067-.273-.1.036-.52.08-1.111.135-1.725a1.526,1.526,0,0,0,1.163.233,2.768,2.768,0,0,0,1.416-1.078c2.022-2.448,4.1-5,4.877-8.04a17.107,17.107,0,0,0,.437-4.141V8.25A4.434,4.434,0,0,0,161.137,6.7Z",
    transform: "translate(43.161 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.113,14.253s3.064,4.529,2.408,6.685,7.223.863,7.223.863.219-8.411,1.752-10.352S131.113,14.253,131.113,14.253Z",
    transform: "translate(54.772 4.384)",
    fill: "#f7c4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.772,19.166s-6.348-5.176-6.129-7.117c0,0-4.816-9.058-6.567-4.529s3.283,9.273,3.283,9.273l6.129,7.979Z",
    transform: "translate(45.072 2.381)",
    fill: "#f7c4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.668,72.375s-5.911,3.666-8.317,2.588-3.283.647-2.627,1.294,14.884,6.254,18.168,5.391,1.614-7.928,1.614-7.928Z",
    transform: "translate(43.717 30.368)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.789,83.693s-1.423,5.931-6.348,5.823c0,0-7.442-.647-4.6,1.941s19.481,3.019,19.481,3.019,0-8.842-3.064-10.783A4.741,4.741,0,0,0,137.789,83.693Z",
    transform: "translate(52.691 34.793)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.039,54.938l.656,15.1s0,7.117,2.408,10.352S136.356,99.8,136.356,99.8h8.319s-2.408-21.782-4.378-24.369c0,0-.875-19.194,2.189-23.507Z",
    transform: "translate(53.471 21.71)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.039,54.938l.656,15.1s0,7.117,2.408,10.352S136.356,99.8,136.356,99.8h8.319s-2.408-21.782-4.378-24.369c0,0-.875-19.194,2.189-23.507Z",
    transform: "translate(53.471 21.71)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.488,44.815s5.035,11.861-4.159,15.312S122.5,63.146,122.5,63.146l-.875,25.016s-10.289,1.294-10.508-1.941V58.833s.219-3.019,7.005-5.607A88.29,88.29,0,0,1,134.1,49.344l.438-5.607Z",
    transform: "translate(46.309 18.247)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.044,17.058a10.617,10.617,0,0,1,5.144.716c1.342.556,2.626,1.43,2.925,2.773.346,1.591-.038,5.161-.478,8.182a55.514,55.514,0,0,0-.266,14.3,14.8,14.8,0,0,0,.962,4.479c1.314,2.372,2.627,13.586,2.627,13.586s-14.447-5.391-21.67-2.157c0,0-.985-22.105-1.094-29.33-.085-5.594,7.113-11.969,9.522-12.185C137.124,17.3,136.64,17.2,138.044,17.058Z",
    transform: "translate(52.689 6.928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.044,16.755a10.619,10.619,0,0,1,5.144.716c1.342.556,2.626,1.43,2.925,2.773.346,1.592-.038,5.161-.478,8.182a55.516,55.516,0,0,0-.266,14.3,22.865,22.865,0,0,0,.962,4.479c.985,2.911,2.627,13.587,2.627,13.587s-14.447-5.392-21.67-2.157c0,0-.985-22.105-1.094-29.33-.085-5.594,7.113-11.969,9.522-12.185C137.124,16.992,136.64,16.9,138.044,16.755Z",
    transform: "translate(52.689 6.8)",
    fill: "#e14b5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.955,27.565,126.413,26.7s-.989-7.507,1.254-7.43l15.383.528S146.332,23.683,141.955,27.565Z",
    transform: "translate(52.691 7.892)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.812,30.119l-17.731-.863s-13.79-4.1-17.729-8.626c0,0,.218-7.979,4.6-8.411L127.3,19.7a11.284,11.284,0,0,0,6.221,2.126l15.381.528S152.19,26.237,147.812,30.119Z",
    transform: "translate(46.831 4.907)",
    fill: "#e14b5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.636,15.159A5.9,5.9,0,0,1,142.5,11.6c1.531-1.941-11.383,2.8-11.383,2.8a22.815,22.815,0,0,1,1.752,3.172,7.944,7.944,0,0,0,3.283.71C138.044,18.286,139.274,16.265,140.636,15.159Z",
    transform: "translate(54.772 4.448)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.994,20.625a7.765,7.765,0,1,0-7.881-7.764A7.823,7.823,0,0,0,136.994,20.625Z",
    transform: "translate(53.926 1.893)",
    fill: "#f7c4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,8.826a8.537,8.537,0,0,1-1.624-3.274L129.4,2.88c1.187.69,2.452-.863,3.814-1.078A5.173,5.173,0,0,1,136,2.613c3.9,1.755,8.975.884,12.109,3.759a3.446,3.446,0,0,1,.968,1.348,4.439,4.439,0,0,1,.175,1.51,17,17,0,0,1-.41,4.05c-.743,2.974-2.735,5.471-4.677,7.865a2.64,2.64,0,0,1-1.359,1.065c-1.127.248-2-.951-2.435-2a21.172,21.172,0,0,1-1.27-4.328,5.624,5.624,0,0,0-.521-1.829c-.677-1.184-2.35-2.305-3.366-3.224S132.831,9.829,131.9,8.826Z",
    transform: "translate(54.046 0.487)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,8.675A8.537,8.537,0,0,1,130.275,5.4L129.4,2.729c1.187.69,2.452-.863,3.814-1.078A5.173,5.173,0,0,1,136,2.461c3.9,1.755,8.975.884,12.109,3.759a3.446,3.446,0,0,1,.968,1.348,4.439,4.439,0,0,1,.175,1.51,17,17,0,0,1-.41,4.05c-.743,2.974-2.735,5.471-4.677,7.865a2.64,2.64,0,0,1-1.359,1.065c-1.127.248-2-.951-2.435-2a21.176,21.176,0,0,1-1.27-4.328,5.624,5.624,0,0,0-.521-1.829c-.677-1.184-2.35-2.305-3.366-3.224S132.831,9.677,131.9,8.675Z",
    transform: "translate(54.046 0.423)",
    fill: "#632652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.306,12.981c.363,0,.656-.629.656-1.4s-.293-1.4-.656-1.4-.658.628-.658,1.4S135.943,12.981,136.306,12.981Z",
    transform: "translate(56.692 4.041)",
    fill: "#f7c4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,37.448s-.438,1.3-2.627,1.08-8.537-.648-8.537,0",
    transform: "translate(54.739 15.585)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.847,89.008a1.8,1.8,0,0,1-.638-.9c-.057.281.118.647.638,1.116,2.845,2.59,19.481,3.021,19.481,3.021v-.216C146.221,92.027,129.683,91.589,126.847,89.008Z",
    transform: "translate(52.692 37.027)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.892,80.285c-3.283.863-17.51-4.745-18.168-5.392a.7.7,0,0,1-.181-.315.766.766,0,0,0-.01.4.775.775,0,0,0,.191.35c.658.647,14.884,6.254,18.168,5.392,1.691-.444,2.067-2.53,2.037-4.451C124.9,78.055,124.456,79.871,122.892,80.285Z",
    transform: "translate(43.717 31.301)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.321,77.15a.331.331,0,0,0,.232-.095.321.321,0,0,0,0-.458.331.331,0,0,0-.464,0,.321.321,0,0,0,0,.458A.331.331,0,0,0,77.321,77.15Z",
    transform: "translate(32.239 32.115)",
    fill: "#67647e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.07,74.231s8.169-.248,10.63-1.975,12.564-3.789,13.175-1.02,12.278,13.776,3.047,13.858S19.494,83.679,17.036,82.2,14.07,74.231,14.07,74.231Z",
    transform: "translate(5.955 29.313)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,82.83c-9.222.073-21.427-1.415-23.886-2.89-1.872-1.124-2.627-5.152-2.865-7.011H14.07s.517,6.491,2.975,7.964S31.709,83.868,40.922,83.8c2.662-.022,3.581-.953,3.531-2.336C44.092,82.293,43.076,82.815,41.1,82.83Z",
    transform: "translate(5.955 30.603)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.093,90.106h18.676A1.921,1.921,0,0,0,166.7,88.2V83.17a1.921,1.921,0,0,0-1.936-1.906H146.093a1.92,1.92,0,0,0-1.934,1.906V88.2A1.92,1.92,0,0,0,146.093,90.106Z",
    transform: "translate(60.294 34.13)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.093,90.106h18.676A1.921,1.921,0,0,0,166.7,88.2V83.17a1.921,1.921,0,0,0-1.936-1.906H146.093a1.92,1.92,0,0,0-1.934,1.906V88.2A1.92,1.92,0,0,0,146.093,90.106Z",
    transform: "translate(60.294 34.13)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.772,75.354H146.1a1.921,1.921,0,0,0-1.936,1.906V82.29A1.921,1.921,0,0,0,146.1,84.2h18.676a1.92,1.92,0,0,0,1.934-1.906V77.26A1.92,1.92,0,0,0,164.772,75.354Z",
    transform: "translate(60.294 31.629)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.093,77.983h18.676a1.921,1.921,0,0,0,1.936-1.906V71.048a1.921,1.921,0,0,0-1.936-1.906H146.093a1.92,1.92,0,0,0-1.934,1.906v5.029A1.92,1.92,0,0,0,146.093,77.983Z",
    transform: "translate(60.294 28.999)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.093,77.983h18.676a1.921,1.921,0,0,0,1.936-1.906V71.048a1.921,1.921,0,0,0-1.936-1.906H146.093a1.92,1.92,0,0,0-1.934,1.906v5.029A1.92,1.92,0,0,0,146.093,77.983Z",
    transform: "translate(60.294 28.999)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.772,62.929H146.1a1.921,1.921,0,0,0-1.936,1.906v5.029a1.921,1.921,0,0,0,1.936,1.906h18.676a1.92,1.92,0,0,0,1.934-1.906V64.835A1.92,1.92,0,0,0,164.772,62.929Z",
    transform: "translate(60.294 26.37)",
    fill: "#0d71e8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.210d60629315fe8b02e9dd627fdca563.svg";
export { ForwardRef as ReactComponent };